import React from 'react'
import { Link, Outlet } from 'react-router-dom';
import { Navigation, NavigationList, NavigationListItem, NavigationListItemRight } from './styled';

const Layout = () => {

  const handleLogout = (e: any) => {
    e.preventDefault();
    document.cookie = `token=; max-age=${0}; Secure; path=/`;
    document.cookie = `refreshToken=; max-age=${0}; Secure; path=/`;
    let currentUrl = window.location.href;
    window.location.replace(`/login?returnUrl=${currentUrl}`);
  }

  return (
    <>
      <Navigation>
        <NavigationList>
          <NavigationListItem>
            <Link to="/">Home</Link>
          </NavigationListItem>
          <NavigationListItem>
            <Link to="/blogs">Blogs</Link>
          </NavigationListItem>
          <NavigationListItem>
            <Link to="/placeholders">Placeholders</Link>
          </NavigationListItem>
          <NavigationListItem>
            <Link to="/photos">Photos</Link>
          </NavigationListItem>
          <NavigationListItem>
            <Link to="/messages">Messages</Link>
          </NavigationListItem>
          <NavigationListItem>
            <Link to="/contact">Contact</Link>
          </NavigationListItem>
          <NavigationListItemRight>
            <Link to="" onClick={(e) => handleLogout(e)}>Log out</Link>
          </NavigationListItemRight>
        </NavigationList>
      </Navigation>
      <Outlet />
    </>
  )
  };

export default Layout